import { useState, useEffect } from 'react'
import { fetchDocContent } from '../api'
import LoadingView from './LoadingView'

const MAX_LINES = 500

export default function ModLogPage() {
  const [text,      setText]      = useState<string | null>(null)
  const [loading,   setLoading]   = useState(false)
  const [error,     setError]     = useState<string | null>(null)
  const [truncated, setTruncated] = useState(false)

  useEffect(() => {
    setLoading(true)
    fetchDocContent('job_log')
      .then((data) => {
        const lines = data.text.split('\n')
        if (lines.length > MAX_LINES) {
          setTruncated(true)
          setText(lines.slice(0, MAX_LINES).join('\n'))
        } else {
          setText(data.text)
        }
      })
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingView />

  if (error) {
    return (
      <div style={{ flex: 1, padding: '24px' }}>
        <div style={{ padding: '10px 14px', background: '#450a0a', color: '#fca5a5', fontSize: '13px', borderRadius: '8px', border: '1px solid #7f1d1d' }}>
          ⚠ {error}
        </div>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px 20px' }}>
      {text ? (
        <>
          <pre
            style={{
              fontFamily: 'var(--font)',
              fontSize: '13px',
              color: 'var(--text)',
              whiteSpace: 'pre-wrap',
              lineHeight: 1.65,
              margin: 0,
            }}
          >
            {text}
          </pre>
          {truncated && (
            <div
              style={{
                marginTop: '16px',
                padding: '10px 0',
                fontSize: '12px',
                color: 'var(--text-muted)',
                opacity: 0.6,
                textAlign: 'center',
                borderTop: '1px solid rgba(255,255,255,0.08)',
                letterSpacing: '0.04em',
              }}
            >
              ---- LOG TRUNCATED, SEE MORE IN GOOGLE DRIVE ----
            </div>
          )}
        </>
      ) : (
        <div style={{ color: 'var(--text-muted)', fontSize: '14px', opacity: 0.6 }}>
          No log entries yet.
        </div>
      )}
    </div>
  )
}
